// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Events.module.css */
.Events_container__Lj1uV {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h1 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 20px;
}

/* Стили для поиска событий */
.Events_event_search_results__BD2nB {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin: 10px 0;
}

.Events_event_search_results__BD2nB div {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.Events_event_search_results__BD2nB div:hover {
  background: #f5f5f5;
}

/* Стили для поиска */
.Events_search_container__YSlCc {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
}

.Events_search_input__4NmDj {
  flex: 1 1;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s;
}

.Events_search_input__4NmDj:focus {
  border-color: #3498db;
  outline: none;
}

.Events_search_button__mDey5 {
  padding: 12px 24px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
}

.Events_search_button__mDey5:hover {
  background-color: #2980b9;
}

/* Список пользователей */
.Events_user_list__YhVwU {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.Events_user_item__ZL7L8 {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.Events_user_item__ZL7L8:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.Events_user_item__ZL7L8 h3 {
  margin: 0 0 10px;
  color: #2c3e50;
}

.Events_user_item__ZL7L8 p {
  margin: 0;
  color: #666;
}

/* Модальное окно */
.Events_modal__GWCrM {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.Events_modal_content__41NBB {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.Events_modal_content__41NBB h2 {
  margin-top: 0;
  color: #2c3e50;
}

.Events_user_events_list__wVkvf {
  margin: 20px 0;
  max-height: 300px;
  overflow-y: auto;
}

.Events_event_item__z17sP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}

.Events_event_item__z17sP:hover {
  background-color: #f8f9fa;
}

.Events_delete_button__uShaj {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.Events_delete_button__uShaj:hover {
  background-color: #c0392b;
}

.Events_add_event_section__PCOz0 {
  margin-top: 20px;
}

.Events_event_select__BYe\\+O {
  width: 100%;
  padding: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
}

.Events_close_button__vyu24 {
  margin-top: 20px;
  padding: 10px 20px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

/* Сообщения */
.Events_loading__1NjwO {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-size: 18px;
}

.Events_no_users__QWL0U {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 18px;
}

.Events_error_message__oHvQW {
  background: #ffe3e3;
  color: #d32f2f;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  text-align: center;
}

@media (max-width: 768px) {
  .Events_container__Lj1uV {
    padding: 10px;
  }

  .Events_search_container__YSlCc {
    flex-direction: column;
  }

  .Events_search_button__mDey5 {
    width: 100%;
  }

  .Events_user_list__YhVwU {
    grid-template-columns: 1fr;
  }

  .Events_modal_content__41NBB {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/Events/Events.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Events.module.css */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\nh1 {\r\n  color: #2c3e50;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Стили для поиска событий */\r\n.event_search_results {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  margin: 10px 0;\r\n}\r\n\r\n.event_search_results div {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.event_search_results div:hover {\r\n  background: #f5f5f5;\r\n}\r\n\r\n/* Стили для поиска */\r\n.search_container {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.search_input {\r\n  flex: 1;\r\n  padding: 12px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.search_input:focus {\r\n  border-color: #3498db;\r\n  outline: none;\r\n}\r\n\r\n.search_button {\r\n  padding: 12px 24px;\r\n  background: #3498db;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.search_button:hover {\r\n  background-color: #2980b9;\r\n}\r\n\r\n/* Список пользователей */\r\n.user_list {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.user_item {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.user_item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.user_item h3 {\r\n  margin: 0 0 10px;\r\n  color: #2c3e50;\r\n}\r\n\r\n.user_item p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n/* Модальное окно */\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal_content {\r\n  background: white;\r\n  padding: 30px;\r\n  border-radius: 8px;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal_content h2 {\r\n  margin-top: 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.user_events_list {\r\n  margin: 20px 0;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.event_item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.event_item:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.delete_button {\r\n  background: #e74c3c;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.delete_button:hover {\r\n  background-color: #c0392b;\r\n}\r\n\r\n.add_event_section {\r\n  margin-top: 20px;\r\n}\r\n\r\n.event_select {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n.close_button {\r\n  margin-top: 20px;\r\n  padding: 10px 20px;\r\n  background: #3498db;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Сообщения */\r\n.loading {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #7f8c8d;\r\n  font-size: 18px;\r\n}\r\n\r\n.no_users {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #999;\r\n  font-size: 18px;\r\n}\r\n\r\n.error_message {\r\n  background: #ffe3e3;\r\n  color: #d32f2f;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 10px;\r\n  }\r\n\r\n  .search_container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .search_button {\r\n    width: 100%;\r\n  }\r\n\r\n  .user_list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .modal_content {\r\n    padding: 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Events_container__Lj1uV`,
	"event_search_results": `Events_event_search_results__BD2nB`,
	"search_container": `Events_search_container__YSlCc`,
	"search_input": `Events_search_input__4NmDj`,
	"search_button": `Events_search_button__mDey5`,
	"user_list": `Events_user_list__YhVwU`,
	"user_item": `Events_user_item__ZL7L8`,
	"modal": `Events_modal__GWCrM`,
	"modal_content": `Events_modal_content__41NBB`,
	"user_events_list": `Events_user_events_list__wVkvf`,
	"event_item": `Events_event_item__z17sP`,
	"delete_button": `Events_delete_button__uShaj`,
	"add_event_section": `Events_add_event_section__PCOz0`,
	"event_select": `Events_event_select__BYe+O`,
	"close_button": `Events_close_button__vyu24`,
	"loading": `Events_loading__1NjwO`,
	"no_users": `Events_no_users__QWL0U`,
	"error_message": `Events_error_message__oHvQW`
};
export default ___CSS_LOADER_EXPORT___;
